import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Title from '../patient/generics/Title';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {pencil} from 'react-icons-kit/icomoon/pencil';
import {bin} from 'react-icons-kit/icomoon/bin';
import Help from '../generics/help';

var Config = require('../../config');

class PlasmaticProduct extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.newRegister = this.newRegister.bind(this);
		this.onEdit = this.onEdit.bind(this);
		this.handleCheck = this.handleCheck.bind(this);

		this.state = {
			filter: "",
			list:[],
			all: false
		}
	}

	componentDidMount(){
		this.reload();
	}

	reload(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product?option='+(this.state.all?"all":"actives"), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({list: response});
			}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	filter(row){
		var res = true;

		if(row !== null){
			var string = row.name+' '+row.code+' '+row.barcode+' '+row.presentation;

			if(string.indexOf(this.state.filter.toUpperCase()) !== -1){
				res = true
			}else{
				res = false
			} 
		}

		return res;
	}

	newRegister(){
		this.props.history.push('/plasmatic_products/new');
	}

	onEdit(id){
		this.props.history.push('/plasmatic_products/edit/'+id);
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	fetch(Config.default.apiGateway.URL+'plasmatic_product?id='+id,{ 
		            method: 'delete',

		            headers: new Headers({
		               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		               'Accept': 'application/json',
		              'Content-Type': 'application/json',
		            })
	          	}).then(res => {
		            if(res.ok){
		              	return res.json();
		            }else{
		              	res.text().then(function(result) {
		                	swal('¡Error!', result, 'error');
		              	});
		            }
		        }).then(res => {
	              	if(res !== undefined){
	                	swal('Buen Trabajo', 'Registro Eliminado','success');
	                	this.reload();
	              	}
	          	})
	        }
	    }.bind(this));
	}

	//Evento para checkbox
	handleCheck =async event => {
		await this.setState({ 
			[event.target.name]: event.target.checked
		});
		this.reload();
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.plasmatic_products.MAIN')} 
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_products"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" 
							placeholder={"Filtro..."} value={this.state.filter} onChange={this.handleChange} />
					</div>

					<div className="col-xs-12 col-sm-2">
							<div className="col-xs-12 col-sm-5">
								<span className="span-min">Ver Todos</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="checkbox" id="all" name="all" 
								checked={this.state.all} onChange={this.handleCheck}/>
							</div>
						</div>

					<div className="col-xs-12 col-sm-1 col-sm-offset-6">
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							onClick={this.newRegister}
							disabled={!this.props.task_plasmatic_product.create}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Nombre</th>
								<th>Codigo</th>
								<th>Codigo de Barras</th>
								<th>Presentación</th>
								<th>Volumen</th>
								<th>Unidades</th>
								<th>Costo</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((list, i)=>{
								return  this.filter(list) ?
									<tr key={i} >
										<td>{list.name}</td>
										<td>{list.code}</td>
										<td>{list.barcode}</td>
										<td>{list.presentation}</td>
										<td>{list.volume}</td>
										<td>{list.units}</td>
										<td>{list.cost_unit}</td>
										<td>
											<button type="button" className="btn btn-info btn-xs"
												onClick={this.onEdit.bind(this, list.id)}
												disabled={!this.props.task_plasmatic_product.update}
												style={{margin:"0 5px"}}>
												<SvgIcon icon={pencil}/>
											</button>

											<button type="button" className="btn btn-info btn-xs"
												onClick={this.onDelete.bind(this, list.id)}
												disabled={!this.props.task_plasmatic_product.delete}
												style={{margin:"0 5px"}}>
												<SvgIcon icon={bin}/>
											</button>
										</td>
									</tr>
								: null
							})}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}
}

export default translate('translations') (PlasmaticProduct);